import React from "react";
import { useLang } from "../lib/i18n";

const FlagRU = () => (
  <span className="inline-block w-7 h-5 rounded-[4px] overflow-hidden border border-border shadow-sm" aria-hidden="true">
    <span className="block h-1/3 bg-white" />
    <span className="block h-1/3 bg-[#0039A6]" />
    <span className="block h-1/3 bg-[#D52B1E]" />
  </span>
);

const FlagES = () => (
  <span className="inline-block w-7 h-5 rounded-[4px] overflow-hidden border border-border shadow-sm" aria-hidden="true">
    <span className="block h-1/4 bg-[#AA151B]" />
    <span className="block h-2/4 bg-[#F1BF00]" />
    <span className="block h-1/4 bg-[#AA151B]" />
  </span>
);

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  const base =
    "flex items-center gap-2 px-3 py-2 rounded-full border-2 bg-white keypad-key min-h-[44px]";
  return (
    <div data-testid="language-switcher" className="flex items-center gap-2">
      <button
        data-testid="language-ru-button"
        aria-label="Русский язык"
        onClick={() => setLang("ru")}
        className={`${base} ${lang === "ru" ? "border-[hsl(var(--ring))] ring-2 ring-[hsl(var(--ring))]/30" : "border-border opacity-70"}`}
      >
        <FlagRU />
        <span className="text-sm font-semibold">RU</span>
      </button>
      <button
        data-testid="language-es-button"
        aria-label="Idioma español"
        onClick={() => setLang("es")}
        className={`${base} ${lang === "es" ? "border-[hsl(var(--ring))] ring-2 ring-[hsl(var(--ring))]/30" : "border-border opacity-70"}`}
      >
        <FlagES />
        <span className="text-sm font-semibold">ES</span>
      </button>
    </div>
  );
};
